import React from "react";
import styles from "../Schedule.module.css";
import Icon from "@/components/ui/display/Icon";

interface EmptyPlaceholderProps {
  hasFilters: boolean;
}

const EmptyPlaceholder: React.FC<EmptyPlaceholderProps> = ({ hasFilters }) => {
  return (
    <div className={styles.emptyPlaceholder} data-testid="schedule-empty">
      {!hasFilters ? (
        <>
          <Icon name="account" size="xl" />
          <h2>Velg ansatte eller prosjekter</h2>
          <p>
            Bruk filteret til venstre for å velge hvem du vil se bookinger for
          </p>
        </>
      ) : (
        <>
          <Icon name="calendar" size="xl" />
          <h2>Ingen bookinger funnet</h2>
          <p>Det er ingen bookinger for valgt periode og filtre</p>
        </>
      )}
    </div>
  );
};

EmptyPlaceholder.displayName = "EmptyPlaceholder";

export default EmptyPlaceholder;
export { EmptyPlaceholder };
